import template from './sw-settings-usage-data-intro.html.twig';
import './sw-settings-usage-data-intro.scss';

const { Component } = Shopware;

/**
 * @private
 *
 * @package services-settings
 */
Component.register('sw-settings-usage-data-intro', {
    template,
});
